# A document may be
#
# - A result (tagged)
# - Uploaded
# - Clipped
#

module.exports = (
  $templateCache,
  $uibModal,
  $timeout,
  Entity,
  User,
  Api
) ->

  return {
    restrict: 'A'

    template: require('./document.html')

    controller: ( $scope, $element, $attrs ) ->

      ## Gotcha: this directive is instantiated as a child of the ProjectController scope
      # in search results, but in an _isolate_ scope in the StepFindings directive
      # This means to "always" pass in a new function from ProjectController, it must also
      # be added as a parameter to StepFindings

      removalConfirmed = ->
        if $scope.warnDocumentRemoval
          return confirm( 'Remove finding?' )
        else
          return true

      $scope.user = User

      $scope.warnDocumentRemoval = $attrs.hasOwnProperty( 'warnDocumentRemoval' )

      $scope.isSearchResult = ()->
        !angular.isUndefined $scope.result

      getDocument = () ->
        if $scope.isSearchResult()
          return $scope.result
        else
          return $scope.doc

      getDocumentId = ()->
        getDocument().id

      $scope.isStarred = () ->
        return Boolean $scope.getStarredDocument()

      $scope.isAllowedToStar = () ->
        return !$scope.getStarredDocument() and $scope.projectPermissions.createProjectStarredDocument \
             or $scope.getStarredDocument() and $scope.projectPermissions.changeProjectStarredDocument

      $scope.getStarredDocument = () ->
        doc = getDocument()
        return $scope.starredDocs[ doc.id ] or (
          User.hasPermission("workflow.enable_starred_docs_by_fingerprint", false) and
          $scope.starredDocsByFingerprint[ doc.fingerprint ]
        )

      $scope.getStarRelevance = () ->
        if $scope.isStarred() && !User.hasTaggingConfigs()
          return $scope.getStarredDocument().relevance_type
        else
          return 'none'

      $scope.openEntityModal = () ->
        entity_decorated = Entity.decorate( $scope.entity )
        entity_decorated.reload()
        originalEntity = angular.copy( entity_decorated )
        manualStepModal = $uibModal.open
          template: require("./EntityModal/entity-modal.html")
          controller: "EntityModalController"
          size: 'lg'
          windowClass: 'entity-modal'
          backdrop: 'static'
          keyboard: false
          resolve:
            starredDoc: -> $scope.getStarredDocument()
            result: -> $scope.result
            entity: -> entity_decorated
            project: -> $scope.project

        manualStepModal.result.then(
          ( closeReason ) ->
          ,
          ( dismissReason ) ->
            $scope.entity = angular.copy( originalEntity )
          )

      $scope.updateStarredDocument = () ->
        $scope.getStarredDocument().$update()

      $scope.unstar = ->
        if removalConfirmed()
          starredDoc = $scope.getStarredDocument()
          starredDoc.$delete()
          $scope.removeStarredDoc(starredDoc)

      $scope.resultNumber = ->
        if not $scope.isWorker then return ''
        page = ($scope.resultsPagination.page || 1) - 1
        $scope.getResultsPerPage() * page + $scope.$index + 1

      $scope.documentLink = () ->
        if $scope.documentIsUpload() && $scope.doc.original
          return $scope.doc.original.download_url
        else if $scope.doc.original?.status == 'completed'
          return $scope.doc.original.view_url
        else
          return null

      $scope.documentIsUpload = () ->
        return $scope.doc.source == 'uploaded'

      $scope.updateDocumentPublishedDate = (doc, publishedDate) ->
        doc.published_date = publishedDate
        doc.$update()

      EMPTY_ARRAY = []

      $scope.getTags = () ->
        return $scope.getStarredDocument()?.tags or EMPTY_ARRAY

      $scope.saveTags = (documentTagIdsToSave) ->
        $scope.saveDocTags(getDocument(), documentTagIdsToSave)

      $scope.isAutoDispositionAvailable = () ->
        document = getDocument()
        # check if any of the auto-disposition fields exists or not null
        return (
          document.auto_disposition_is_adverse? ||
          document.auto_disposition_risk_tags? ||
          document.auto_disposition_justification?
        )
  }
